export default "__VITE_ASSET__BGhQByV9__"